import { Spreadsheet } from '@syncfusion/ej2-spreadsheet';
import { ExcelDataService } from '../../DataService/ExcelDataService';

import { Grid, Filter, Page, Sort, RecordClickEventArgs } from '@syncfusion/ej2-grids';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { Toastr } from '../../Helpers/Toastr';
import { App } from '../../App';
import { ConfirmModal } from '../../Helpers/ConfirmModal';

export class ExcelUploadOverviewManager {

    constructor(private containerElement: JQuery) { }
    
    private viewWorkbookModalHelper : ModalHelper;

    private workbookGrid : Grid;

    private workbookContentWrapper : JQuery<HTMLElement>;

    private isUserAdmin : boolean
    

    public initialize() {
        var self = this;

        self.isUserAdmin = self.containerElement.data('is-user-admin') == 'true' || self.containerElement.data('is-user-admin') == 'True';
        console.log(this.isUserAdmin);

        this.viewWorkbookModalHelper = new ModalHelper();
        this.viewWorkbookModalHelper.createModal("view-workbook-popup", true);

        Grid.Inject(Filter, Page, Sort);

        self.initializeUploadAndWorkbooksTable();
    }

    private initializeUploadAndWorkbooksTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var uploadedWorkbooksContainer = self.containerElement.find('#upload-and-workbooks-container');

        self.workbookContentWrapper = self.containerElement.find('#workbook-content-wrapper');;

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#ExcelUploadGrid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;
        

        //var uploadWorkbookManager = new UploadExcelWorkbookManager(self.containerElement);
        // uploadWorkbookManager.uploadContainerCreatedEvent.subscribe(() => {
        //     loadingContainer.addClass('d-none');
        //     uploadContainer.removeClass('d-none');
        // });        
        
        // uploadWorkbookManager.workbookUploadingEvent.subscribe(() => {
        //     self.workbookContentWrapper.css('height', '81dvh');
        // });        
        
        var refreshGrid = () => {
            
            if(self.workbookGrid != undefined) {
                if(self.workbookGrid.pageSettings.currentPage == 1) {
                    self.workbookGrid.refresh();
                }
                else {
                    self.workbookGrid.goToPage(1);
                }
            }
        }

        // uploadWorkbookManager.workbookSetEvent.subscribe(() => {
        //     self.workbookContentWrapper.css('height', '91dvh');
        //     refreshGrid();
        // });

        // uploadWorkbookManager.workbookOpenFailedEvent.subscribe(() => {
        //     self.workbookContentWrapper.css('height', '91dvh');
        // });

        // uploadWorkbookManager.initialize();

        if(App.SideBar != undefined) {
            App.SideBar.workbookSetFromSideBar.subscribe(() => {
                refreshGrid();
            });
        }

        let data: DataManager = new DataManager({
            url: '/api/company/excel/uploads',
            adaptor: new WebApiAdaptor
        });

        self.workbookGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                columns: [
                    { field: 'UploadDateTimeString', headerText: 'Created', width: 80, autoFit: true},
                    { field: 'CustomerName', headerText: 'Customer', width: 200,},
                    { field: 'VesselName', headerText: 'Vessel', width: 200,},
                    { field: 'WorkbookName', headerText: 'Workbook', autoFit: true, width: 300 },
                    { field: 'SheetAndLines', headerText: 'Sheets | Lines', textAlign: 'Center', width: 150,},
                    { field: 'UploadedBy', headerText: 'Uploader', width: 150 },
                    { field: 'StatusText', headerText: 'Status', autoFit: true, template: '${getStatus(data.Status, data.StatusText)}'  },
                    { field: 'ExtraActions', headerText: '', allowFiltering: false, autoFit: true, textAlign: 'Right', template: '${getWorksheetActions(data.Id, data.Status, data.CanProcess)}' }
                ],
                allowSorting: false,
                allowPaging: true,
                allowFiltering: false,
                allowSelection: false,
                enablePersistence: true,
                pageSettings: { pageSize: 20 },
                created: () => {
                    gridContentElement = gridContentElement.find('.e-content')
                    loadingContainer.addClass('d-none');
                    uploadedWorkbooksContainer.removeClass('d-none');
                },
                recordClick: (args: RecordClickEventArgs) => {
                    if (args.target != undefined && args.rowData != undefined) {
                        var parsedTarget = $(args.target); 
                        var workbookId = args.rowData["Id"];
                        var status = args.rowData["Status"];
                        
                        if((parsedTarget.data('action') == 'view-workbook' || parsedTarget.parent().data('action') == 'view-workbook') && workbookId != undefined) {
                            
                            var fetchUrl = status == 2 ? `/api/company/excel/${workbookId}/processworkbook` : `/api/company/excel/${workbookId}/uploadworkbook`;

                            self.viewWorkbookModalHelper.load(`?handler=ViewWorkbook`, undefined, () => {
                                let spreadsheet: Spreadsheet = new Spreadsheet( {
                                    showRibbon: this.isUserAdmin,
                                    showAggregate: false,
                                    showFormulaBar: false,
                                    allowEditing: false,
                                    openUrl: '/api/company/excel/open',
                                    created: (): void => {
                                        fetch(fetchUrl) // fetch the remote url
                                            .then((response) => {
                                                response.blob().then((fileBlob) => { // convert the excel file to blob
                                                    let file = new File([fileBlob], "Sample.xlsx");
                                                    spreadsheet.open({ file: file }); // open the file into Spreadsheet
                                                })
                                            })
                                    },
                                    openComplete: (args: any) => {
                                        if(args.response.data == 'NeedPassword' || args.response.data == 'InCorrectPassword') {
                                            //spreadsheetElement.removeClass('d-none');
                                        }
                                        else if(args.response.data == 'UnsupportedFile') {
                                            //spreadsheetElement.removeClass('d-none');
                                        }
                                        else {
                                            spreadsheet.selectRange('A1:A1');

                                            setTimeout(() => {
                                                spreadsheet.freezePanes(0, 0);  
                                            }, 250)
                                                                                      
                                        }
                                    },
                                });
                                spreadsheet.appendTo('#view-workbook-container');
                            }, 
                            undefined);
                        }
                        else if((parsedTarget.data('action') == 'remove-workbook' || parsedTarget.parent().data('action') == 'remove-workbook') && workbookId != undefined) {
                            var removeResultFunc = (success : boolean) => {
                                if(success) {
                                    Toastr.Success('Workbook removed', 'We\'ve successfully removed the workbook.');
                                    self.workbookGrid.refresh();
                                }
                                else {
                                    Toastr.Error('Workbook not removed', 'Due to an error the workbook wasn\'t removed. Try again later.')
                                }
                            }

                            new ConfirmModal().initialize('Remove workbook', 'Are you sure you want to remove this workbook?</br>This action cannot be reverted.', () => {
                                if(status == 2) {
                                    ExcelDataService.deleteProcessedWorkbook(workbookId, (success) => {
                                        removeResultFunc(success);
                                    })
                                }
                                else {
                                    ExcelDataService.deleteUploadWorkbook(workbookId, (success) => {
                                        removeResultFunc(success);
                                    })
                                }
                            }, () => {
                            }, 'Confirm', 'Cancel')
                        }
                    }    
                }
            });
        self.workbookGrid.appendTo('#ExcelUploadGrid');
    }

}